import type { TActiveGateway, TActiveNode } from '../types'

export const getIdentifier = (node: TActiveNode | TActiveGateway): string => {
  return (node as TActiveNode).nodeIdentifier || (node as TActiveGateway).gatewayIdentifier
}
